import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { CollaboratorRepository } from "../domain/CollaboratorRepository";
import { Collaborator } from "../domain/Collaborator";
import { CollaboratorDataFull } from "~/context/CollaboratorsData/domain/CollaboratorDataFull";

export function createApiCollaboratorRepository(): CollaboratorRepository {
  return new APICollaboratorRepository();
}

export class APICollaboratorRepository
  extends APIRepository
  implements CollaboratorRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  getCollaboratorsByCompany(companyId: string): Promise<Collaborator[]> {
    console.log("getCollaboratorsByCompany companyId: " + companyId);
    return this.doGet<Collaborator[]>("/api/collaborators/company/" + companyId.toString());
  }
//TODO: revisar si es company/collaborator o collaborator/company
  getCollaborator360ByCompanyAndId(companyId: string, collaboratorId: string): Promise<CollaboratorDataFull>{
    console.log("getCollaborator360ByCompanyAndId companyId: " + companyId + " collaboratorId: " + collaboratorId);
    return this.doGet<CollaboratorDataFull>("/api/collaborators/collaborator/" + collaboratorId.toString() + "/company/" + companyId.toString());
  }
}


